import { useEffect } from 'react';

/**
 * Pauses CSS animations inside every [data-loop] element while it is off screen
 * by toggling .is-offscreen (see App.css).
 */
export default function usePauseOffscreen(rootRef) {
  useEffect(() => {
    const root = rootRef.current;
    if (!root || !('IntersectionObserver' in window)) return undefined;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => entry.target.classList.toggle('is-offscreen', !entry.isIntersecting));
    });
    const elements = Array.from(root.querySelectorAll('[data-loop]'));
    elements.forEach((element) => observer.observe(element));

    return () => {
      observer.disconnect();
      elements.forEach((element) => element.classList.remove('is-offscreen'));
    };
  }, [rootRef]);
}
